// Slide decks associated with Object-Oriented Programming (OOP) sprint 5

import { xyz_n_1of4, xyz_n_2of4_PAaA, xyz_n_2of4, xyz_n_MidtermExam, xyz_n_MidtermExam_PAaA, xyz_n_4of4_PAaA, xyz_n_4of4 } from './SL00000Sprint00TTR'
import { orderedListSlide, submissionPercentage } from './SLSprint00'

import { list24500Sprint04 } from '../ActivityLists/AL24500Sprint04'
import { list24500Sprint05 } from '../ActivityLists/AL24500Sprint05'

const sprint = 5
const activityList = () => { return list24500Sprint05(sprint) }
const activityListPrevious = () => { return list24500Sprint04(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const oop_5_1of4 = () => {
	const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Quiz, Lab, and Reflection',
			'Different in that we will have our Midterm Exam in class next Tuesday with in-person attendance required',
			`Similar in that we will have two weeks to complete all sprint ${sprint} assignments`,
			`Similar in that we will have sprint ${sprint-1} Demos and Retrospectives on Thursday`,
			`Similar in that we will complete Discussion Board ${sprint} as a scrum team in class on Thursday` ])
	}
	return xyz_n_1of4(null, null, sprintAndActivityLists, sprintPlanningExpectations) 
}

// Session 2 of 4: Thursday
/* Todo: Figure out where this breakout session should be included in the slide deck
import { breakoutStandard } from './SLSprint00'

const breakoutRequirementsGUI = 'Graphical User Interfaces plus Action Listeners'
const breakoutGUI = () => {
	return breakoutStandard( 
		`${breakoutRequirementsGUI} Breakout`, 
		`In this breakout session on “${breakoutRequirementsGUI}” your team will discuss:`, [
		'Recall: AWT... What does that stand for?',
		'Recall: Swing, SWT, and JavaFX',
		'Recall: How is Android related to Java?',
		'Review: Layout Managers in Java',
		'Review:Class Inheritance vs. Composition vs. Interfaces',
		'Action Listeners',
		'Action Listener, Classes, Objects, and Interfaces'
	 ])
}
*/

const oop_5_2of4_PAaA =  {
	...xyz_n_2of4_PAaA(5, sprint),
	announcements: [ 'Reminder that next Tuesday is our Midterm Exam with in-person attendance required**' ]
}
const oop_5_2of4 = () => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:3, submitted:3 },
			{ name: 'Quiz', due:3, submitted:3 },
			{ name: 'Lab', due:3, submitted:3 },
			{ name: 'Reflection', due:3, submitted:3 }])
	}
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
			'Feedback from Assignments & Reflections', [
			`Fantastic submission percentage in sprint ${sprint-1}! Thank you!!`,
			'Lab assignments not graded/posted', 
			`If you are not where you want to be in the class after sprint ${sprint-1}, we need to talk.` ])
	}
	return xyz_n_2of4(oop_5_2of4_PAaA, oop_5_3of4_PAaA, sprintAndActivityLists, 
		metricsSubmissionPercentage, retrospective) 
}

// Session 3 of 4: Tuesday
const oop_5_3of4_PAaA = xyz_n_MidtermExam_PAaA(5)
const oop_5_3of4 = () => { return xyz_n_MidtermExam(oop_5_3of4_PAaA, oop_5_4of4_PAaA, sprintAndActivityLists) }

// Session 4 of 4: Thursday
const oop_5_4of4_PAaA = xyz_n_4of4_PAaA('Complete through activity 5', sprint)
const oop_5_4of4 = () => { return xyz_n_4of4(oop_5_4of4_PAaA, null, sprintAndActivityLists ) }

export const oop_5_slidedeckTTR = [ oop_5_1of4, oop_5_2of4, oop_5_3of4, oop_5_4of4 ]